/* eslint-disable no-unused-vars */
import * as S from './SelectedContent.styled';

export const LocationSelectedItemName = ({ itemData, env }) => {
  if (itemData.type === 'continent') {
    return (
      <S.ItemBox>
        <S.HighlightedText env={env}>Continent: </S.HighlightedText>
        <S.StrongText>{itemData.continent_name}</S.StrongText>
      </S.ItemBox>
    );
  }
  if (itemData.type === 'country') {
    return (
      <S.ItemBox>
        <S.HighlightedText env={env}>Country:</S.HighlightedText>{' '}
        <S.StrongText>
          {itemData.country_name} - {itemData.country_code}
        </S.StrongText>
      </S.ItemBox>
    );
  }
  if (itemData.type === 'region') {
    return (
      <S.ItemBox>
        <S.HighlightedText env={env}> Region: </S.HighlightedText>
        <S.StrongText>{itemData.region_name}</S.StrongText> / {itemData.country_name} -
        {itemData.country_code}
      </S.ItemBox>
    );
  }
  if (itemData.type === 'city') {
    return (
      <S.ItemBox>
        {itemData.country_name} - {itemData.country_code} / {itemData.region_name} /
        <S.HighlightedText env={env}> City: </S.HighlightedText>
        <S.StrongText>{itemData.city}</S.StrongText>
      </S.ItemBox>
    );
  }
};
